<template>
  <v-app id="inspire">
    <v-content class="register-frame">
      <v-container class="fill-height" fluid>
        <v-row align="center" justify="center">
          <v-col cols="12" sm="8" md="4">
            <v-card class="elevation-12 ml-5">
              <v-card-text>
                <form>
                  <form-wrapper :validator="$v.form">
                    <div style="margin-bottom: 20px">
                      <form-summary />
                    </div>

                    <form-group name="email">
                      <template slot-scope="{ attrs }">
                        <v-text-field
                          outlined
                          :rules="[rules.required, rules.email]"
                          v-bind="attrs"
                          append-icon="mdi-email"
                          v-model="email"
                          label="Email"
                          @input="$v.email.$touch()"
                        />
                      </template>
                    </form-group>
                  </form-wrapper>
                  <p class="typo__p" v-if="submitStatus === 'OK'">
                    ¡Gracias por registrase!
                  </p>
                  <p class="typo__p" v-if="submitStatus === 'ERROR'">
                    Por favor, corrija los campos.
                  </p>
                  <p class="typo__p" v-if="submitStatus === 'PENDING'">
                    Enviando...
                  </p>
                </form>
              </v-card-text>

              <v-card-actions>
                <v-btn
                  v-if="!this.$store.state.auth.newuser"
                  color="red darken-1"
                  to="/dashboard/usuario"
                  style="text-transform:none;color:#fff;"
                  >Cancelar</v-btn
                >
                <v-spacer />
                <v-btn
                  color="#9ccc3c"
                  @click.prevent="submit"
                  :disabled="$v.$invalid"
                  style="text-transform:none;color:#fff;"
                  >Actualizar</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
        <v-snackbar v-model="snackbar">
          {{ snackbarText }}
          <v-btn color="blue" text @click="snackbar = false">Cerrar</v-btn>
        </v-snackbar>
      </v-container>
    </v-content>
  </v-app>
</template>

<!--suppress JSUnresolvedVariable -->
<script>
import imageCompressor from "vue-image-compressor";
import { mapActions, mapState } from "vuex";
import {
  minLength,
  numeric,
  maxLength,
  required,
  email,
} from "vuelidate/lib/validators";
export default {
  // eslint-disable-next-line vue/no-unused-components
  components: { imageCompressor },

  computed: {
    ...mapState("auth", {
      name: "name",
      username: "username",
    }),
  },
  data() {
    return {
      rules: {
        required: (value) => !!value || "Requerido.",
        counter: (value) => value.length <= 20 || "Max 20 characters",
        email: (value) => {
          const pattern = /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+(?:[A-Z]{2}|com|org|net|gov|gob|mil|biz|info|mobi|mx|name|aero|jobs|museum|es)/;
          return pattern.test(value) || "Correo e-mail invalido.";
        },
      },
      scale: 50,
      quality: 50,
      name: "",
      last_name: "",
      email: "",
      phone: "",
      form: {
        picture: null,
        street: "",
        extNum: "",
        intNum: "",
        postalCode: "",
        settlement: "",
        city: "",
        municipality: "",
        estate: "",
        shareProfile: false,
        name: "",
        last_name: "",
        email: "",
        phone: "",
      },
      actualPicture: "",
      submitStatus: null,
      snackbar: false,
      snackbarText: "",
    };
  },
  validations: {
    name: { required, name },
    email: { required, email },
    phone: { required },
    form: {
      street: { minLength: minLength(1), maxLength: maxLength(50) },
      extNum: { minLength: minLength(1), maxLength: maxLength(50) },
      intNum: { minLength: minLength(1), maxLength: maxLength(50) },
      postalCode: {
        minLength: minLength(1),
        numeric,
        maxLength: maxLength(5),
      },
      settlement: {
        minLength: minLength(1),
        maxLength: maxLength(50),
      },
      city: { minLength: minLength(1), maxLength: maxLength(50) },
      municipality: {
        minLength: minLength(1),
        maxLength: maxLength(50),
      },
      estate: { minLength: minLength(1), maxLength: maxLength(50) },
    },
  },
  methods: {
    ...mapActions("auth", {
      setUserInf: "setUserInf",
      getUserProfile: "getUserProfile",
    }),
    getFiles(obj) {
      console.log(obj);
    },
    onFileChanged(e) {
      this.form.picture = e.target.files[0];
      const input = this.$refs.photo;
      const files = input.files;
      if (files && files[0]) {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.actualPicture = e.target.result;
        };
        reader.readAsDataURL(files[0]);
        this.$emit("input", files[0]);
      }
      // do something
    },
    pickFile() {
      this.$refs.photo.click();
    },
    keymonitor(option) {
      var id = option;
      document.getElementById(id).click();
    },
    toLowerCas() {
      this.form.email = this.form.email.toLowerCase();
      this.$v.form.email.$touch();
    },
    submit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.submitStatus = "ERROR";
      } else {
        this.form.name = this.name;
        this.form.last_name = this.last_name;
        this.form.email = this.email;
        this.form.phone = this.phone;
        this.submitStatus = "PENDING";
        let formData = this.getformData();
        this.setUserInf({ formData, username: this.username })
          .then(() => {
            if (this.$store.state.auth.newuser) {
              this.$store.state.auth.newuser = false;
            }
            this.submitStatus = "OK";
            this.snackbar = true;
            this.snackbarText =
              "Agregando información... redirigiendo a inicio";
            this.$store.state.auth.name = this.form.name;
            this.$store.state.auth.last_name = this.form.last_name;
            this.$store.state.auth.email = this.form.email;
            this.$store.state.auth.phone_number = this.form.phone;
            this.$router.push({
              name: "userDash",
            });
          })
          .catch((err) => {
            this.snackbar = true;
            this.snackbarText = `Error: ${err.response.data.nonFieldErrors[0]}`;
          });
      }
    },
    getformData() {
      let formData = new FormData();
      for (let key in this.form) {
        // noinspection JSUnfilteredForInLoop
        formData.append(key, this.form[key]);
      }
      if (typeof formData["picture"] !== "object") {
        delete formData["picture"];
      }
      return formData;
    },
  },
  created() {
    this.getUserProfile(this.username).then((res) => {
      this.actualPicture = res["picture"];
      delete res["picture"];
      this.form = res;
      this.name = this.$store.state.auth.name;
      this.last_name = this.$store.state.auth.last_name;
      this.email = this.$store.state.auth.email;
      this.phone = this.$store.state.auth.phone_number;
    });
  },
};
</script>
<style lang="scss" scoped>
.register-frame {
  background-image: url("~@/assets/img/backgrounds/fondoazul.png");
  background-position: center center;
  background-size: cover;
}

.img-actual {
  height: 150px;
}
</style>
